import BrandFour from "../components/BrandFour";
import FeaturesTwo from "../components/FeaturesTwo";
import HomeFourAbout from "../components/HomeFourAbout";
import HomeFourBanner from "../components/HomeFourBanner";
import HomeFourContact from "../components/HomeFourContact";
import HomeFourTeam from "../components/HomeFourTeam";
import ServicesFour from "../components/ServicesFour";
import TestimonialFour from "../components/TestimonialFour";
import FooterFour from "../footer/FooterFour";
import HeaderFour from "../header/HeaderFour";

export default function HomeFour(){
    return(
        <>
        <HeaderFour/>
        <main>
        <HomeFourBanner/>
        <BrandFour/>
        <FeaturesTwo/>
        <HomeFourAbout/>
        <ServicesFour/>
        <HomeFourTeam/>
        <TestimonialFour/>
        <HomeFourContact/>
        </main>
        <FooterFour/>
        </>
    )
}